export default [
    {
        path: 'relatorio-cancelamento',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-cancelamento' */
            '@/views/ambulatorio/relatorio-cancelamento/Index'
        ),
        redirect: 'relatorio-cancelamento/index',
        children: [
            {
                name: 'ambulatorio-relatorio-cancelamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-cancelamento' */
                    '@/views/ambulatorio/relatorio-cancelamento/List.vue'
                ),
            },
        ],
    },
]
